import axios from 'axios';
import { API_URL } from '../config/constants';

// react-select 옵션 객체 { value, label }가 넘어오면 value만 보냄
const toParam = (v) => (v != null && typeof v === 'object' && 'value' in v ? v.value : v);

export async function getCurrentProcessStartedAt({ sumDsId } = {}) {
  if (!sumDsId) return null;
  const response = await axios.post(`${API_URL}/monitoring-manage/summarizedDatas`, { sumDsId }, {
    withCredentials: true,
  });
  return response.data?.startedAt ?? null;
}

export async function getModelTypes({sumDsId} = {}) {
  if(!sumDsId) throw new Error("sumDsId is required");
  const response = await axios.get(`${API_URL}/android/getModelTypes`, {
    params: { sumDsId },
  });
  return response.data;
}

export async function getModelNames({sumDsId, modelType} = {}) {
    const params = {};
    if (sumDsId != null) params.sumDsId = sumDsId;
    const typeVal = toParam(modelType);
    if (typeVal != null && typeVal !== '') params.modelType = typeVal;
    const response = await axios.get(`${API_URL}/android/getModelNames`, {
        params,
        withCredentials: true,
    });
    return response.data;
}

export async function getModelNos({sumDsId, modelType, modelName} = {}) {
    const params = {};
    if (sumDsId != null) params.sumDsId = sumDsId;
    const typeVal = toParam(modelType);
    const nameVal = toParam(modelName);
    if (typeVal != null && typeVal !== '') params.modelType = typeVal;
    if (nameVal != null && nameVal !== '') params.modelName = nameVal;
    const response = await axios.get(`${API_URL}/android/getModelNos`, {
        params,
        withCredentials: true,
    });
    return response.data;
}

export async function getSensorLabels({sumDsId}){
    const params = {};
    if(sumDsId !=null) params.sumDsId = sumDsId;
    const response = await axios.get(`${API_URL}/android/getSensorLabels`, {
        params,
        withCredentials: true,
    });
    return response.data;
}

export async function getUtilBar({ sumDsId, startDate, endDate, modelType, modelName, modelNo } = {}) {
    const body = {};
    if (sumDsId != null) body.sumDsId = sumDsId;
    if (startDate != null && String(startDate).trim() !== '') body.startDate = startDate;
    if (endDate != null && String(endDate).trim() !== '') body.endDate = endDate;
    const typeVal = toParam(modelType);
    const nameVal = toParam(modelName);
    const noVal = toParam(modelNo);
    if (typeVal != null && typeVal !== '') body.modelType = typeVal;
    if (nameVal != null && nameVal !== '') body.modelName = nameVal;
    if (noVal != null && noVal !== '') body.modelNo = noVal;
    const response = await axios.post(`${API_URL}/android/getUtilBar`, body, {
        withCredentials: true,
    });
    return response.data;
}

export async function getWorkerBar({ sumDsId, startDate, endDate, modelType, modelName, modelNo } = {}) {
  try {
    const res = await axios.post(
      `${API_URL}/android/getWorkerBar`,
      {
        sumDsId,
        startDate,
        endDate,
        modelType: modelType || "",
        modelName: modelName || "",
        modelNo: modelNo || "",
      },
      {
        withCredentials: true,
      }
    );

    const rows = res.data; // [{workerEmail, workerName, totalProduceSum, utilRate, ...}, ...]

    // 차트에 쓰기 좋게 숫자 변환(중요: SUM 결과는 문자열로 오는 경우 많음)
    const chartData = rows.map(r => ({
      workerName: r.workerName,
      totalProduceSum: Number(r.totalProduceSum || 0),
      utilRate: Number(r.utilRate || 0),
    }));

    return chartData;
  } catch (e) {
    console.error(e);
  }
}

/** 일별 비가동 현황 + 가동율 (차트용) - getDailyDowntime API */
export async function getDailyDowntime({ sumDsId, startDate, endDate } = {}) {
  if (sumDsId == null) return [];
  const body = {
    sumDsId,
    startDate: startDate != null && String(startDate).trim() !== '' ? startDate : undefined,
    endDate: endDate != null && String(endDate).trim() !== '' ? endDate : undefined,
  };
  const res = await axios.post(`${API_URL}/android/getDailyDowntime`, body, { withCredentials: true });
  const rows = Array.isArray(res.data) ? res.data : [];
  return rows.map(r => ({
    date: r.date,
    name: typeof r.date === 'string' ? r.date.slice(0, 10) : r.date,
    unplannedDuration: Number(r.unplannedDuration) || 0,
    plannedDuration: Number(r.plannedDuration) || 0,
    totalDuration: Number(r.totalDuration) || 0,
    operatingRate: Number(r.operatingRate) || 0,
    plannedHours: (Number(r.plannedDuration) || 0) / 3600,
    unplannedHours: (Number(r.unplannedDuration) || 0) / 3600,
    totalHours: (Number(r.totalDuration) || 0) / 3600,
  }));
};
